module.exports = __webpack_public_path__ + "img/logo-login.79e15a74.png";